/* BALIVENO v7: keep the displayed colour name in sync with native variant radios. */
(() => {
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    const fieldset = input.closest('variant-radios fieldset.variant-input-wrapper');
    if (!fieldset) return;
    const label = fieldset.querySelector('.form__label-info');
    if (label) label.textContent = ' — ' + input.value;
  });
})();
